// src/components/About.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BASE_URL from '../config';

export default function About() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/content/sections/slug/about-us/items`)
      .then(res => setItems(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
      Annapoorneshwari Pre/Higher Primary School
      </Typography>
      <Divider sx={{ mb: 4 }} />

      {items.map(item => (
        <Accordion key={item.ItemID} sx={{ mb: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">{item.Title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              component="div"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item.Content || '' }}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
}
